import { SchemaDefinition } from "../validator/schema-definition-interface";

/**
 * The schema definition for the stored location object.
 */
export const storedLocationSchema: SchemaDefinition = {
	Name: 'stored-location',
	Properties: {
		AddressName: { Type: 'string' },
		Address1: { Type: 'string' },
		Address2: { Type: 'string' },
		City: { Type: 'string' },
		Region: { Type: 'string' },
		PostalCode: { Type: 'string' },
		AirportCode: { Type: 'string' },
		ContactName: { Type: 'string' },
		PhoneNumber: { Type: 'string' },
		Instructions: { Type: 'string' }
	}
}